import { render, staticRenderFns } from "./ck.vue?vue&type=template&id=74bbe933&scoped=true"
import script from "./ck.vue?vue&type=script&lang=js"
export * from "./ck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bbe933",
  null
  
)

export default component.exports